export type { PageData } from "./pagedata";
export type { Movie } from "./movie";
export { Genres } from "./genre";
